import React, { useEffect, useState } from 'react'
import cn from 'classnames'
import styles from './Exchange.module.sass'
import Main from './Main'
import Balance from './Balance'
import Currency from './Currency'
import Trades from './Trades'
import Table from './Table'
import { useMediaQuery } from 'react-responsive'
import Charts from './Charts'
import { useSelector } from 'react-redux'
import { useSelectedMarket } from './Spot'
import CurrencyDropdown from './CurrencyDropdown'
import useMarketDepthSubscription from '../../hooks/useMarketDepthSubscription.js'

const navigation = ['Chart', 'Order books', 'Trades']

const AdvancedLeftLayout = ({ children, ...props }) => {
  const [activeIndex, setActiveIndex] = useState(0)
  const isTablet = useMediaQuery({ query: '(max-width: 1179px)' })
  const markets = useSelector((state) => state.crypto.markets.markets)
  const {
    selectedMarket,
    setSelectedMarket,
  } = useSelectedMarket();
    useMarketDepthSubscription(selectedMarket);

  useEffect(() => {
    if (markets?.length > 0 && !selectedMarket) {
      setSelectedMarket(markets?.[0]?.instanceId)
    }
  }, [markets, selectedMarket])

  return (
    <div className={cn('exchange', styles.exchange)}>
      <Main selectedMarket={selectedMarket} />
      {
        isTablet && (
          // <Currency onMarketSelect={setSelectedMarket} />
          <CurrencyDropdown
            onMarketSelect={setSelectedMarket}
            selectedMarket={selectedMarket}
          />
        )
      }
      <div className={styles.nav}>
        {navigation.map((x, index) => (
          <button
            className={cn(styles.link, {
              [styles.active]: index === activeIndex,
            })}
            onClick={() => setActiveIndex(index)}
            key={index}
          >
            {x}
          </button>
        ))}
      </div>
      {isTablet ? (
        <>
          {children}
          {activeIndex === 0 && (
            <div className={cn('box', styles.box)}>
              <Charts selectedMarket={selectedMarket} />
              <Table />
            </div>
          )}
          {activeIndex === 1 && (
            <div className={styles.box}>
              <Balance selectedMarket={selectedMarket} />
            </div>
          )}
          {activeIndex === 2 && (
            <div className={styles.box}>
              {/* <Currency onMarketSelect={setSelectedMarket} /> */}
              <Trades selectedMarket={selectedMarket} />
            </div>
          )}
        </>
      ) : (
        <div className={styles.row}>
          <div className={styles.col}>
            {children}
            <Currency onMarketSelect={setSelectedMarket} />
          </div>
          <div className={styles.col}>
            <div className={styles.row}>
              <Trades selectedMarket={selectedMarket}/>
              <div className={styles.chartContainer}>
                <Charts selectedMarket={selectedMarket} />
              </div>
            </div>
            <Table />
          </div>
        </div>
      )}
    </div>
  )
}

export default AdvancedLeftLayout
